import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Menu from "./Components/Menu/Menu";
import Footer from "./Components/Footer/Footer";

import Accueil from "./Pages/Accueil/Accueil";
import Nous_Sommes from "./Pages/Nous_Sommes/Nous_Sommes";
import TelealarmeISS from "./Pages/TelealarmeISS/TelealarmeISS";
import PasserelleISS from "./Pages/PasserelleISS/PasserelleISS";
import Kube from "./Pages/Kube/Kube";
import Openlift from "./Pages/Openlift/Openlift";
import Blog from "./Pages/Blog/Blog";
import Contact from "./Pages/Contact/Contact";
import Demo from "./Pages/Demo/Demo";
import Devis from "./Pages/Devis/Devis";
import Projets from "./Pages/Projets/Projets";
import DeletAccount from "./Pages/DeleteAccount/DeleteAccount";
import PrivacyPolicy from "./Pages/PrivacyPolicy/PrivacyPolicy";

// ✅ 6 articles
import BlogPost2G3G from "./Components/BlogPosts/BlogPost2G3G";
import BlogPostPannes from "./Components/BlogPosts/BlogPostPannes";
import BlogPostPreventive from "./Components/BlogPosts/BlogPostPreventive";
import BlogPostDesincarceration from "./Components/BlogPosts/BlogPostDesincarceration";
import BlogPostDepannage from "./Components/BlogPosts/BlogPostDepannage";
import BlogPostAscenseurConnecte from "./Components/BlogPosts/BlogPostAscenseurConnecte";

const Page = ({ title }) => (
  <main
    style={{
      minHeight: "calc(100dvh - 68px)",
      display: "grid",
      placeItems: "center",
    }}
  >
    <h1
      style={{
        fontFamily:
          'system-ui, -apple-system, "Segoe UI", Roboto, Inter, Arial, sans-serif',
      }}
    >
      {title}
    </h1>
  </main>
);

const NotFound = () => (
  <main
    style={{
      minHeight: "calc(100dvh - 68px)",
      display: "grid",
      placeItems: "center",
    }}
  >
    <h1
      style={{
        fontFamily:
          'system-ui, -apple-system, "Segoe UI", Roboto, Inter, Arial, sans-serif',
      }}
    >
      404 — Page introuvable
    </h1>
  </main>
);

export default function App() {
  return (
    <BrowserRouter>
      <Menu />

      <Routes>
        <Route path="/" element={<Accueil />} />
        <Route path="/nous-sommes" element={<Nous_Sommes />} />
        <Route path="/openlift" element={<Openlift />} />

        {/* Page liste Produits */}
        <Route path="/produits" element={<Page title="Produits" />} />

        {/* ✅ Pages produits individuelles */}
        <Route path="/produits/telealarme-iss" element={<TelealarmeISS />} />
        <Route path="/produits/passerelle-iss" element={<PasserelleISS />} />
        <Route path="/produits/kube" element={<Kube />} />

        {/* ✅ Blog */}
        <Route path="/blog" element={<Blog />} />

        {/* ✅ Routes articles */}
        <Route path="/blog/:slug" element={<BlogPost2G3G />} />
        <Route path="/blog/:slug" element={<BlogPostPannes />} />
        <Route path="/blog/:slug" element={<BlogPostPreventive />} />
        <Route path="/blog/:slug" element={<BlogPostDesincarceration />} />
        <Route path="/blog/:slug" element={<BlogPostDepannage />} />
        <Route path="/blog/:slug" element={<BlogPostAscenseurConnecte />} />

        {/* Optionnel : fallback si slug inconnu */}
        <Route path="/blog/:slug" element={<NotFound />} />

        <Route path="/contact" element={<Contact />} />
        <Route path="/demo" element={<Demo />} />
        <Route path="/devis" element={<Devis />} />
        <Route path="/projets-collaboratifs" element={<Projets />} />

        {/* ✅ Suppression de compte OPENlift */}
        <Route path="/delete-account" element={<DeletAccount />} />

        {/* ✅ Politique de confidentialité OPENlift */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
}